export default __webpack_public_path__ + "static/media/NeueMontreal-Medium.4e14d824.woff2";